export default __webpack_public_path__ + "static/media/3435 cutlery top.37375ca1.png";